import { render } from "./RedacaoListRelatorio.vue?vue&type=template&id=c8a334ea&ts=true"
import script from "./RedacaoListRelatorio.vue?vue&type=script&lang=ts"
export * from "./RedacaoListRelatorio.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/diogooliveira/Documents/workspace_personal/aureo/aureov2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QForm,QSelect,QBtn,QTable,QSpace,QInput,QIcon,QTd,QTooltip});
